// 审核代办页面的 接口集合
import request from "../request.js";

// 获得审核列表 ---- 刘献根
export const getList = function (data) {
    return request({
        url: 'optSysApplyRecord/selAuditSysAppRedList',
        method: 'post',
        data
    })
}

// 获得审核列表新 ---- 赵健强
export const getListNew = function (data) {
    return request({
        url: 'applyRecord/getPageRecords',
        method: 'post',
        data
    })
}

// 审计代办 -- 审核   by 刘献根
export const auditSysTenantOpenSys = function (data) {
    return request({
        url: 'optSysApplyRecord/auditSysApplyRecord',
        method: 'post',
        data
    })
}

//  查询申请详情 --- 叶凡（2025-09-04 接口替换）
export const getRecordDetail = function (data) {
    return request({
        url: 'applyRecord/getRecordDetail',
        method: 'post',
        data
    })
}

// 获取码表 --- 郑智慧
export const getDict = function (data) {
    return request({
        url: 'sysDict/getDictMulti',
        method: 'post',
        data
    })
}

//企业维护-查询企业基本数据--郑智慧
export const selectTenantInterimInfoBase = function (data) {
    return request({
        url: 'optSysApplyRecord/selectTenantInterimInfo',
        method: 'post',
        data
    })
}

//企业维护-提交审核-修改记录--郑智慧
export const updateTenantInterim = function (data) {
    return request({
        url: 'optSysApplyRecord/updateTenantInterim',
        method: 'post',
        data
    })
}

//专家信息变更 信息回显--郑智慧
export const getAuditInfo = function (data) {
    return request({
        url: 'ngsExpertReview/getAuditInfo',
        method: 'post',
        data
    })
}

//专家信息变更 审核 --郑智慧
export const auditZjMsg = function (data) {
    return request({
        url: 'optSysApplyRecord/changeExpertInfo',
        method: 'post',
        data
    })
}

//实名认证信息 --俞祥东
export const checkOtherRealNameInfo = function (data) {
    return request({
        url: 'optSysApplyRecord/checkOtherRealNameInfo',
        method: 'post',
        data
    })
}

//实名认证信息审核 --俞祥东
export const auditOtherRealNameInfo = function (data) {
    return request({
        url: 'optSysApplyRecord/auditOtherRealNameInfo',
        method: 'post',
        data
    })
}


//企业申诉-审核 --俞祥东
export const auditEnterPriseAppealRecord = function (data) {
    return request({
        url: 'optSysApplyRecord/auditEnterPriseAppealRecord',
        method: 'post',
        data
    })
}

//审核企业-企业账户修改信息查看
export const getAccountInfo = function (data) {
    return request({
        url: 'optSysApplyRecord/tenantAccountEcho',
        method: 'post',
        data
    })
}

//审核企业-企业账户修改信息审核
export const auditTenantAccount = function (data) {
    return request({
        url: 'optSysApplyRecord/auditTenantAccount',
        method: 'post',
        data
    })
}


export const getZjDeal = function (data) {
    return request({
        url: 'applyRecord/getZjDeal',
        method: 'post',
        data
    })
}
